// import { useEffect, useRef, useState,} from "react";

import { useEffect, useRef, useState, useCallback } from "react";
const clients = [
  {
    name: "Instagram",
    image: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg",
    url: "https://www.instagram.com/digitalcanto?igsh=amRld2dnNDV5dTlr&utm_source=qr",
    description: "Our Instagram is a visual space filled with creativity, inspiration, and daily updates. From behind-the-scenes moments to impactful designs and stories, we showcase our journey authentically. We focus on building a strong community, sharing meaningful content, and creating visual experiences that connect with our audience."
  },
  {
    name: "Facebook",
    image: "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_(2019).png",
    url: "https://www.facebook.com/profile.php?id=61574721231496",
    description:
      "Our Facebook page is a place to connect, engage, and stay updated. We share important announcements, valuable content, and interactive posts to keep our community informed. It’s a platform where conversations happen, relationships grow, and our audience stays closely connected with our brand."
  },
  {
    name: "X (Twitter)",
    image: "images/twitter-x.png",
    url: "https://x.com/DigitalCanto",
    description: "Our Twitter presence delivers quick updates, insights, and conversations in real time. We share thoughts, trends, and news that matter, keeping our audience informed and engaged. It’s a fast-paced platform where we connect through meaningful discussions and stay relevant in the digital world."
  },
  {
    name: "LinkedIn",
    image: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png",
    url: "https://www.linkedin.com/company/digitalcanto/",
    description: "Our LinkedIn page highlights professional insights, industry updates, and meaningful achievements. We share knowledge-driven content, success stories, and valuable resources that support growth, collaboration, and long-term professional relationships within our network."
  },
  {
    name: "YouTube",
    image: "https://upload.wikimedia.org/wikipedia/commons/0/09/YouTube_full-color_icon_%282017%29.svg",
    url: "https://www.youtube.com/@digitalcanto",
    description: "Our YouTube channel is where ideas come to life through engaging videos, tutorials, and stories. We share valuable insights, practical tips, and creative content designed to educate, inspire, and entertain. Every video is crafted to help audiences learn, grow, and stay connected with our brand."
  },
  {
    name: "Pinterest",
    image: "images/pinterest.png",
    url: "#",
    description: "Our Pinterest profile is a curated collection of ideas, visuals, and inspiration. We share creative designs, concepts, and trends that spark imagination, support planning, and help audiences discover fresh ideas through engaging and visually appealing content."
  },
  {
    name: "Messenger",
    image: "images/messenger-logo.png",
    url: "#",
    description: "Our Messenger channel is designed for quick, personal, and reliable communication. We use it to provide timely responses, share updates, and support conversations in real time, ensuring smooth interaction and a helpful experience for everyone who connects with us."
  },
  {
    name: "threads",
    image: "images/threads.png",
    url: "https://www.threads.net/",
    description: "Our Threads presence focuses on authentic conversations, thoughts, and community engagement. We share short-form insights, updates, and ideas in a friendly, relatable way, encouraging open interaction and meaningful connections beyond traditional social media boundaries."
  }
];

export default function ClientsList() {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const intervalRef = useRef(null);

  const slidesPerView = isMobile ? 1 : 2;
  const totalSlides = Math.ceil(clients.length / slidesPerView);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Stop auto scroll
  const stopAutoScroll = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  // Start auto scroll
  const startAutoScroll = useCallback(() => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % totalSlides);
    }, 3000);
  }, [stopAutoScroll, totalSlides]);

  // Auto scroll lifecycle
  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, [startAutoScroll, stopAutoScroll]);

  return (
    <section
      className="relative max-w-full mx-auto px-4 py-20 bg-primary h-44 mb-64"
      onMouseEnter={stopAutoScroll}
      onMouseLeave={startAutoScroll}
    >
      <div className="overflow-hidden rounded-3xl">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {Array.from({ length: totalSlides }).map((_, slideIndex) => (
            <div key={slideIndex} className="flex w-full flex-shrink-0 gap-6 px-4">
              {clients
                .slice(
                  slideIndex * slidesPerView,
                  slideIndex * slidesPerView + slidesPerView
                )
                .map((client) => (
                  <div
                    key={client.name}
                    onClick={() => window.open(client.url, "_blank")}
                    className="flex-1 bg-white rounded-3xl shadow-xl p-8 cursor-pointer hover:-translate-y-1 hover:shadow-2xl transition-all h-[300px]"
                  >
                    <img src={client.image} alt={client.name} className="h-20 mb-6" />
                    <h3 className="text-2xl font-bold mb-2">{client.name}</h3>
                    <p className="text-gray-600">{client.description}</p>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center gap-3 mt-10">
        {Array.from({ length: totalSlides }).map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`h-3 rounded-full transition-all ${
              index === i ? "w-10 bg-blue-600" : "w-3 bg-gray-300"
            }`}
          />
        ))}
      </div>
    </section>
  );
}
